export default __webpack_public_path__ + "static/media/frame8.b8557152.webp";